import { render, staticRenderFns } from "./Normalizer.vue?vue&type=template&id=5f88a90e&scoped=true"
import script from "./Normalizer.vue?vue&type=script&lang=js"
export * from "./Normalizer.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=5f88a90e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88a90e",
  null
  
)

export default component.exports